import { Text } from "@sveabank/cc-common";

type Props = {
	firstName: string;
	lastName: string;
	ssn: string;
	children?: React.ReactNode;
};

const GuarantorInfoBox: React.FC<Props> = ({ firstName, lastName, ssn, children }: Props) => (
	<div className="tablet:flex-col tablet:justify-center tablet:gap-0 flex flex-row justify-between gap-2">
		<span>
			<Text bold>{`${firstName} ${lastName}`}</Text> {children}
		</span>
		<span>{ssn}</span>
	</div>
);

export default GuarantorInfoBox;
